import { motion } from 'framer-motion';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';

export const AdminLogin = ({ credentials, setCredentials, onSubmit }) => {
  return (
    <div className="min-h-screen bg-halo-charcoal flex items-center justify-center p-4" data-testid="admin-login">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="bg-halo-surface rounded-2xl p-8 w-full max-w-md shadow-2xl"
      >
        <div className="text-center mb-8">
          <h1 className="font-heading text-3xl text-halo-charcoal">Admin HALO</h1>
          <p className="text-halo-text mt-2">Panel de Administración</p>
        </div>

        <form onSubmit={onSubmit} className="space-y-6">
          <div>
            <Label htmlFor="username">Usuario</Label>
            <Input
              id="username"
              value={credentials.username}
              onChange={(e) => setCredentials(prev => ({ ...prev, username: e.target.value }))}
              className="mt-2"
              data-testid="admin-username"
            />
          </div>
          <div>
            <Label htmlFor="password">Contraseña</Label>
            <Input
              id="password"
              type="password"
              value={credentials.password}
              onChange={(e) => setCredentials(prev => ({ ...prev, password: e.target.value }))}
              className="mt-2"
              data-testid="admin-password"
            />
          </div>
          <Button type="submit" className="w-full bg-halo-brown hover:bg-halo-charcoal" data-testid="admin-login-btn">
            Iniciar Sesión
          </Button>
        </form>
      </motion.div>
    </div>
  );
};
